export default __webpack_public_path__ + "static/media/Sage's Belt of the Aureate.2294a129.jpg";